import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { IFieldPreferences } from '@app/shared/types';
import { CountryFormatService } from '@shared/services';
import { POSITION_LEFT } from '@config/global-constants';
import { get, invoke, isFunction, isNil } from 'lodash';
import { ValidatorFn } from '@angular/forms';

@Component({
  selector: 'xux-input-currency',
  templateUrl: 'xux-input-currency.component.html',
  styleUrls: ['xux-input-currency.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class XuxInputCurrencyComponent implements OnInit {
  @Input() public field: IFieldPreferences = {};

  public currencySign: string;
  public position: string = POSITION_LEFT;
  public precision: number;
  public defaultValueByClear: number;
  public autoPaddingZero: boolean = true;
  public stopPrecisionValidator: boolean = false;

  public inputClass: string = '';

  public notRoundInitValue: boolean;

  public disabled: boolean;
  public numberMultipleOfValidator: (step: number) => ValidatorFn;

  public constructor(
    private readonly countryFormatService: CountryFormatService,
  ) {}

  public ngOnInit(): void {
    this.currencySign =
      invoke(this.field?.widgetData, 'currencySymbolFn') ??
      this.countryFormatService.getCurrencySymbol();
    this.position =
      invoke(this.field?.widgetData, 'positionFn') ?? this.position;
    this.precision =
      invoke(this.field?.widgetData, 'precisionFn') ??
      this.countryFormatService.getCurrencyPrecision();
    this.defaultValueByClear =
      invoke(this.field?.widgetData, 'defaultValueByClearFn') ?? null;
    this.autoPaddingZero = get(
      this.field,
      ['widgetData', 'autoPaddingZero'],
      true,
    );
    this.stopPrecisionValidator = get(
      this.field,
      ['widgetData', 'stopPrecisionValidator'],
      false,
    );
    this.disabled = isFunction(this.field?.disabled)
      ? invoke(this.field, 'disabled')
      : get(this.field, 'disabled', false);
    const numberMultipleOfValidatorFn = get(
      this.field?.widgetData,
      'numberMultipleOfValidatorFn',
    );
    if (!isNil(numberMultipleOfValidatorFn)) {
      this.numberMultipleOfValidator = numberMultipleOfValidatorFn;
    }
    this.inputClass = get(this.field, 'widgetData.inputClass', this.inputClass);
  }
}
